/**
 * @desc 确定装柜信息提交
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.CabinFactoryPlanCabinetCabinRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/cabinMasterFactoryScattered/planCabinet`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
